import Ember from 'ember';
import { registerWaiter, unregisterWaiter } from '@ember/test';
export async function openModal(templateElement, customSelector) {
  const selector = customSelector ?? 'market-context-manager';
  const contextManager = document.querySelector(selector);
  if (!contextManager) {
    throw new Error(`Could not find ${selector}`);
  }
  if (customSelector && contextManager.tagName !== 'MARKET-CONTEXT-MANAGER') {
    throw new Error(`Invalid tag for ${customSelector}, got: ${contextManager.tagName}, expected: MARKET-CONTEXT-MANAGER`);
  }
  const templateTagName = templateElement.tagName.toLowerCase();
  if (templateTagName !== 'template') {
    throw new Error(`Expected modifier to be applied to a template element, but got '${templateTagName} instead'`);
  }
  const modal = templateElement.firstElementChild;
  if (!['market-modal-partial', 'market-modal-full', 'market-dialog', 'market-blade', 'market-sheet'].includes(modal?.tagName.toLowerCase())) {
    throw new Error('Could not find a market-modal-partial, market-modal-full, market-dialog, market-blade, or market-sheet element in template');
  }
  if (!modal.classList.contains('disable-all-glass-global-css') && !modal.classList.contains('disable-glass-global-css')) {
    modal.classList.add('ember-glass-opt-in');
  }
  function alwaysWait() {
    return false;
  }
  function contextContentsChangedHandler(event) {
    if (contextManager && event.detail.action === 'marketNewDialogOpened' && event.detail.currentDialog.el === modal) {
      Ember.testing && unregisterWaiter(alwaysWait);
      contextManager.removeEventListener('marketContextContentsChanged', contextContentsChangedHandler);
    }
  }
  contextManager.addEventListener('marketContextContentsChanged', contextContentsChangedHandler);
  Ember.testing && registerWaiter(alwaysWait);
  await contextManager.open(modal);
  return modal;
}
export async function dismissModal(modal) {
  const context = modal.parentElement;
  function alwaysWait() {
    return false;
  }
  function dialogClosedHandler(event) {
    if (event.detail.action === 'marketDialogClosed' && event.detail.currentDialog.el === modal) {
      Ember.testing && unregisterWaiter(alwaysWait);
      context.removeEventListener('marketContextContentsChanged', dialogClosedHandler);
    }
  }
  context.addEventListener('marketContextContentsChanged', dialogClosedHandler);
  if (modal.tagName === 'MARKET-DIALOG') {
    // This function should always close the modal, even if it's persistent,
    // so we need to turn off `persistent` here. This also ensures the
    // `marketContextContentsChanged` event is fired, and the test waiter
    // registered below will correctly be unregistered by our `dialogClosedHandler`.
    modal.persistent = false;
  }
  Ember.testing && registerWaiter(alwaysWait);
  await modal.dismiss();
}